import { useState } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ListItem from '@mui/material/ListItem';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { StyledSolrNodeChip } from './styles';
import Status from '../../elements/status/Status';
import Text from '../../elements/text/Text';

const SolrNodeListItem = ({ instance, solrNode, onStartNode, onStopNode }) => {
  const { t } = useTranslation();

  const [solrProcessing, setSolrProcessing] = useState(false);

  const handleStartNode = async (subscriptNum) => {
    setSolrProcessing(true);
    await onStartNode(subscriptNum);
    setSolrProcessing(false);
  };

  const handleStopNode = async (subscriptNum) => {
    setSolrProcessing(true);
    await onStopNode(subscriptNum);
    setSolrProcessing(false);
  };

  return (
    <ListItem>
      <ListItemText data-testid="solr-list-item-text">
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Text>
            {instance.name}-{solrNode.subscriptNumber}
          </Text>
          <Status
            instanceState={instance.status}
            solrRunning={solrNode.status}
          />
          <StyledSolrNodeChip label={'Solr Node'.toUpperCase()} size="small" />
        </Box>
      </ListItemText>

      <ListItemSecondaryAction>
        <Box sx={{ display: 'flex' }}>
          {solrProcessing ? (
            <Button disabled size="small">
              {t('pending', { ns: 'buttons' })}
            </Button>
          ) : solrNode.status ? (
            <Button
              aria-label={`node${solrNode.subscriptNumber}-button`}
              color="inherit"
              size="small"
              onClick={() => handleStopNode(solrNode.subscriptNumber)}
            >
              {t('stop', { ns: 'buttons' })}
            </Button>
          ) : (
            <Button
              aria-label={`node${solrNode.subscriptNumber}-button`}
              size="small"
              onClick={() => handleStartNode(solrNode.subscriptNumber)}
            >
              {t('start', { ns: 'buttons' })}
            </Button>
          )}
        </Box>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

SolrNodeListItem.propTypes = {
  instance: PropTypes.object.isRequired,
  solrNode: PropTypes.object.isRequired,
  onStartNode: PropTypes.func.isRequired,
  onStopNode: PropTypes.func.isRequired,
};

export default SolrNodeListItem;
